class CollectionInit{
  
  constructor(){
    /*
    if($('body').is(('.page-diamonds'))) new Collection();
    else if ($('body').is('.template-product')) {
      new CollectionModal();
    }
    else $('body').data('shortList', new ShortList());
    */
    $('.quiz-block').each(function(){
      $(this).data('quizBlock', new QuizBlock($(this)))
    })
  }
}

class QuizBlock {
  
  constructor(el){
    var __this=this;
    this.el=el;
    this.shortlist=$('body').data('shortList');
    this.url=theme.routes.stoneQueryPath;
    this.container=this.el.find('> *').first();
    this.block=this.el.find('.question-block');
    this.response=this.el.find('.response');
    this.resultBtn=this.el.find('[href="#results"]');
    this.resetBtn=this.el.find('[href="#reset"]');
    this.answer=this.block.find('.answer');
    this.cnt=0;
    this.loading=null;
    //this.setWidth();
    this.answer.find('[href="#select"]').on('click', function(){
      __this.runQuestion($(this).closest('.answer'));
      //__this.setWidth();
    })
    this.answer.find('a').on('click', function(e){
      
      e.preventDefault();
      
      if($(this).is('[href="#next"]')){
        __this.cnt=__this.returnCnt($(this))+1;
        __this.setPosition();  
      }
      if($(this).is('[href="#prev"]')){
        __this.cnt=__this.returnCnt($(this))-1;
        __this.setPosition();
      }
    })
    this.resultBtn.on('click', function(){
      if($(this).is('.active')) {
        __this.runTheJewels();
      }
    })
    this.resetBtn.on('click', function(){
      __this.runReset();
    })
  }
  runReset(){
    var __this=this;
    this.loading.positionInit();
    this.el.attr('data-reset', 1);
    setTimeout(function(){
      __this.answer.removeClass('active');
      __this.response.html('');
      __this.el.removeAttr('data-results').removeAttr('data-ready');
      __this.el.find('#StoneContainer').html('');
      __this.setPosition('reset');
      setTimeout(function(){ 
        __this.loading.positionEnd(); 
        __this.el[0].offsetHeight;
        __this.el.removeAttr('data-reset', 0);
      }, 500);
    }, 1000)
  }
  setWidth(){
    var __this=this;
    var last=this.el.find('.answer.active').last();
    var baseOffset=this.container.offset().left;
    var offset=0;
    if(!last.length){
      var baseOffset=0;
    }else{
      var lastEl=last.closest('.question-block');
      var index=lastEl.index();
      if(index==(this.block.length-1)) {
        var offsetEl=this.el.find('.stones-block');
      }else{
        var offsetEl=lastEl.next();
      }
      offset=offsetEl.offset().left;
    }
    var totalOffset=$(window).width()+offset;
    
    this.el.css('overflow', 'auto');
    this.container.css('max-width', totalOffset+'px');
  }
  runTheJewels(){
    var __this=this;
    if(this.loading==null) this.loading=new Loading($('body'));
    this.loading.positionInit();
    setTimeout(function(){ 
      __this.runFilter(); 
    }, 100); 
  }
  returnCnt(el){
    var index=el.closest('.question-block').index();
    return index;
  }
  setPosition(mode){
    var __this=this;
    console.log(mode+'    mode');
    if(mode=='results') var blockPos=this.el.find('.results-block').position().left;
    else if (mode=='reset') var blockPos=0;
    else var blockPos=this.block.eq(this.cnt).position().left;
    this.container.css('transform', 'translateX(-'+blockPos+'px)');
  }
  
  runQuestion(el){
    var __this=this;
    var active=1;
    el.addClass('active').siblings().removeClass('active');
    
    var block=el.closest('.question-block');
    var index=block.index();
    index++;
    index=index<10 ? '0'+index : index;
    var question=block.find('.actual--question').html();
    var answer=block.find('.actual--answer').html();
    var response=this.response.eq(block.index());
    response.html('<h3><span class="number">'+index+'.</span>'+question+'</h3><p>'+answer+'</p>')
    
    this.el[0].offsetHeight;
    this.block.each(function(){
      if(!$(this).find('.answer.active').length) active=0;
    })
    if(active){
      this.el.attr('data-ready', 1);
      this.resultBtn.addClass('active');
    }else {
      this.el.removeAttr('data-ready');
      this.resultBtn.removeClass('active');
    }
  }
  
  runFilter(){
    var __this=this;
    this.filterArray=[];
    this.queryArray=[];
    this.dataArray=[];
    this.block.each(function(){
      var key=null;
      var keyEl=$(this).find('.question');
      if(keyEl.length) {
        key=keyEl.attr('data-question');
      }
      var answerEl=$(this).find('.answer.active');
      var answerArray=answerEl.attr('data-answer').split('-');
      var intArray=[key, answerArray];
      __this.filterArray.push(intArray);
    })
    this.fetchResults;
    this.el.attr('data-results', 1);
    this.setPosition('results');
    this.createQueries();
  }
  createQueries(){
    var __this=this;
    this.flatten(this.filterArray, 0, '');
    this.cnt=0;
    this.runQuery(this.cnt);
  }
  flatten(array, index, content){
    var key=array[index][0];
    var innerArray=array[index][1];
    var hasArray=typeof array[index+1]=='object' ? 1:0;
    for(var x=0; x<innerArray.length; x++) {
      var baseContent=content+''+key+'='+innerArray[x];
      if(hasArray) {
        baseContent+='&';
        this.flatten(array, index+1, baseContent)
      } else {
        this.queryArray.push(baseContent);
      }
    }
  }
  
  runQuery() {
    var __this=this;
    var filters=this.queryArray[this.cnt];
    //console.log(filters);
    $.ajax({
      url: this.url+'&origin=L&'+filters,
      async: false,
      cache: false
      }).done(function(data) {
        __this.runSetup(data);
        __this.cnt++;
        if(__this.cnt<__this.queryArray.length) __this.runQuery();
        else {
          __this.sortStones();
        }
      }).fail(function(data) {
        console.log('failed'+data);
        $("<h2>Ooops. Looks like the feed <em>STILL</em> isn't working!").appendTo('#StoneContainer')
        setTimeout(function(){ __this.loading.positionEnd(); }, 500 );
    });
  }
  
  runSetup(data){
    var __this=this;
    $.each(data.stones, function(index, stone){
      __this.dataArray.push(stone);
    })
  }
  
  sortStones(){
    var __this=this;
    this.stoneArray=[];
    var arrayLength=this.dataArray.length;
    var stoneLength=5;
    var offset=arrayLength/stoneLength;
    for(var x=0; x<stoneLength; x++) {
      var index=Math.floor(x*offset);
      this.stoneArray.push(this.dataArray[index]);
    }
    this.displayStones();
    //setTimeout(function(){ __this.loading.positionEnd(); }, 500 );
  }
  
  displayStones() {
    var __this=this;
    var items=[];
    var item={};
    $.each(this.stoneArray, function(index, stone){     
      var hasStone=1;
      if(stone.image=='') hasStone=0;
      
      item = {
        id: stone.public_code,
        shape: stone.shape,
        key: stone.key,
        carat: Number(stone.carat).toFixed(2),
        cert_num: stone.cert_num,
        url: stone.url, 
        clarity: stone.clarity, 
        color: stone.color, 
        cut: stone.cut_grade, 
        price: theme.Currency.formatMoney(stone.price*100), 
        price_taxes: theme.Currency.formatMoney(stone.price_inc_taxes*100), 
        depth: stone.m_depth,
        length: stone.m_length, 
        width: stone.m_width, 
        dimensions: stone.m_depth+' x '+stone.m_length+' x '+stone.m_width, 
        image: stone.image
      }
      
      if(hasStone) item.hasStone=1;
      items.push(item);
      
    })
    
    for(var x=0; x<items.length; x++) {
      var item=items[x];
      $.data(__this, item.id, new CollectionStone(item, x, __this)); 
    }
    //this.setupContainerHeight();
    //$(this.selectors.moreBtn).removeAttr('data-inactive');
    setTimeout(function(){ __this.loading.positionEnd(); }, 500 );
    
  }
  
  removeContainerHeight(){
    
  }
}

class CollectionModal {
  
  constructor(){
    var __this=this;
    this.init=0;
    this.el=$('.theme-modal--stone');
    this.close=this.el.find('[href="/close"]');
    this.el.appendTo('body');
    this.shortlist=new ShortList();
    this.initStoneBtn();
    $('body').on('initStoneBtn', function(){ // bit of a hack... from pair.js
      __this.initStoneBtn();
    })
    this.close.on('click', function(e){
      e.preventDefault();
      $('body').removeAttr('data-stone-modal');
    })
  }
  
  initStoneBtn(){
    var __this=this;
    if(this.init) this.stoneBtn.off();
    this.stoneBtn=$('[href="#stone"]');
    this.stoneBtn.on('click', function(e){
      e.preventDefault();
      if(!__this.init) {
        new Collection(__this.shortlist);
        __this.init++;
      }
      $('body').attr('data-stone-modal', 1);
    })
  }
}

class Collection{
  
  constructor(shortlist){
    var __this=this;
    
    if(typeof shortlist=='undefined') this.shortlist=new ShortList();
    else this.shortlist=shortlist;
    
    this.url=theme.routes.stoneQueryPath;
    this.curr=0;
    this.perPage=16;
    
    this.loading=null;
    
    this.selectors={
      container: '#StoneContainer',
      filterContainer: '.filter.filter--stone',
      template: '#StoneTemplate',
      templateEmpty: '#StoneTemplateEmpty', 
      moreBtn: '#moreStones'
    };
    this.moreBtn=$('#moreStones');
    this.moreBtn.on('click', function(e){
      e.preventDefault();
      __this.curr++;
      __this.loading.positionInit();
      $('body')[0].offsetHeight;
      setTimeout(function(){ __this.runQuery(); }, 250);
    })
    
    $(window).resize(function(){ __this.setupContainerHeight(); })
    //if(this.loading==null) this.loading=new Loading($(this.selectors.container).parent());
    if(this.loading==null) this.loading=new Loading($('body'));
    
    var source=$(this.selectors.template).html();
    this.template=Handlebars.compile(source); 
    
    this.initFilters();
    setTimeout(function(){ __this.runQuery(); }, 250);
  }
  removeContainerHeight(){
    var __this=this;
    var el=$(this.selectors.container);
    el.height('auto');
  }
  setupContainerHeight() {
    var __this=this;
    var el=$(this.selectors.container);
    var lastEl=el.find('> div').last();
    var offset=0;
    var transformMatrix=lastEl.css('transform');
    if(transformMatrix!='none') {
      var matrix=transformMatrix.replace(/[^0-9\-.,]/g, '').split(',');
      offset=matrix[13] || matrix[5];
    }
    
    var totalHeight=lastEl.offset().top-el.offset().top+lastEl.outerHeight()-offset;
    el.css('height', totalHeight+'px');
  }
  initFilters(){
    var __this=this;
    $('.proxy--swatch').each(function(index){
      var el=$(this);
      el.data('filter', new FilterItem(el, __this.selectors.filterContainer, index, __this));
    })
  }
  runFilter(){
    var __this=this;
    this.curr=0;
    var el=$(this.selectors.container);
    this.setupContainerHeight();
    this.loading.positionInit();
    
    el.each(function(){
      setTimeout(function(){
        el.addClass('loading')
      }, 300)
      setTimeout(function(){ 
        el.removeClass('loading');
        el.html('');
        __this.runQuery(); 
      }, 500);
    })
    
    el.find('> div').each(function(index){
      var el=$(this);
      var duration=index*25;
      setTimeout(function(){ el.addClass('product--stone__final') }, duration);
    })
    
    //$(this.selectors.container).html('');
  }
  getFilterQuery(){
    var query='';
    var hasAmp=1;
    $('.proxy--swatch').each(function(index){
      var intQuery=$(this).data('filter').returnQuery();
      
      if(intQuery.indexOf('undefined')==-1){
        if(!hasAmp){
          hasAmp=1;
        }else {
          query+='&';
        }
        query+=intQuery;
      }
    });
    
    return query;
  }
  runQuery(){
    
    var __this=this;
    
    var from=this.curr*this.perPage;
    var filters=this.getFilterQuery();
    
    $.ajax({
      url: this.url+'from='+from+'&origin=L'+filters,
      async: false,
      cache: false
      }).done(function(data) {
        __this.runSetup(data);
      }).fail(function(data) {
        console.log('failed'+data);
        $('#StoneContainer').parent().find('> *').first().hide();
        $('<div class="indentless padding-top-col"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><img src="https://media.tenor.com/MRCIli40TYoAAAAi/under-construction90s-90s.gif" style="width: 100px; margin-right: 40px;"><br><h2 class="margin-top-col indentless">Ooops! Looks like the feed isn\'t working!<br/>Maybe check back tomorrow!</h2></div>').appendTo('#StoneContainer')
        setTimeout(function(){ __this.loading.positionEnd(); }, 500 );
    });
  }
  
  runSetup(data){
    var __this=this;
    var items=[];
    var item={};
    $.each(data.data.diamonds_by_query.items, function(index, stone){
      
      var shape=stone.diamond.certificate.shape;     
      var hasStone=1;
      var hasVideo=1;
      var videoURL='';
      if(stone.diamond.image=='') hasStone=0;
      if(stone.diamond.video==''||stone.diamond.video==null) hasVideo=0;
      if(hasVideo) videoURL=stone.diamond.video.replace('/500/500', '/200/200');
      
      console.log(stone.diamond.video)
      item = {
        id: stone.diamond.id,
        shape: shape,
        key: stone.diamond.id,
        carat: Number(stone.diamond.certificate.carats).toFixed(2),
        cert_num: stone.diamond.certificate.certNumber,
        cert_url: stone.diamond.certificate_URL,
        url: stone.diamond.certificate.image,
        clarity: stone.diamond.certificate.clarity, 
        color: stone.diamond.certificate.color, 
        cut: stone.diamond.certificate.cut, 
        price: theme.Currency.formatMoney(stone.price), 
        price_taxes: theme.Currency.formatMoney(stone.price*100), 
        depth: stone.diamond.certificate.depth,
        length: stone.diamond.certificate.length, 
        width: stone.diamond.certificate.width, 
        dimensions: stone.diamond.certificate.depth+' x '+stone.diamond.certificate.length+' x '+stone.diamond.certificate.width, 
        image: stone.diamond.image,
        video: videoURL
      }
      
      if(hasStone) item.has_stone=1;
      if(hasVideo) item.has_video=1;
      
      items.push(item);
      
    })
    
    for(var x=0; x<items.length; x++) {
      var item=items[x];
      $.data(__this, item.id, new CollectionStone(item, x, __this)); 
    }
    this.setupContainerHeight();
    $(this.selectors.moreBtn).removeAttr('data-inactive');
    setTimeout(function(){ __this.loading.positionEnd(); }, 500 );
    
    data = {
      items: items
    }
    
    //$(this.selectors.container).append(this.template(data)); 
  }
}
class CollectionStone {
  
  constructor(item, index, root){
    var __this=this;
    this.index=index;
    this.duration=this.index*25;
    this.root=root;
    this.shortlist=this.root.shortlist;
    this.item=item;
    this.el={};
    this.modal={};
    this.active=0;
    this.isInit=0;
    this.activeClass='active';
    this.baseClass='.product--stone__base';
    
    this.selectors={
      elClass: '.stone--',
      container: '#StoneContainer',
      template: '#StoneItemTemplate',
      templateEmpty: '#StoneTemplateEmpty', 
      modalTemplate: '#StoneModalTemplate'
    };
    
    var source=$(this.selectors.template).html();
    this.template=Handlebars.compile(source);
    this.createStone();
  }
  
  createStone(){
    var __this=this;
    
    var data={};
    data = {
      item: this.item
    }
    
    $(this.selectors.container).append(this.template(data));
    this.el=$(this.selectors.elClass+this.item.id);
    this.el[0].offsetHeight;
    this.el.find(this.baseClass).on('click', function(e){
      e.preventDefault();
      __this.root.removeContainerHeight();
      __this.displayStone();
    })
    setTimeout(function(){ __this.el.removeClass('product--stone__init') }, __this.duration);
  }
  
  displayStone(){
    var __this=this;
    
    if(this.active) {
      this.el.removeClass(this.activeClass);
      this.active=0;
    }else{
      if(!this.isInit) this.initModal();
      else this.setActive();
    }
  }
  
  initModal(){
    var __this=this;
    
    this.isInit=1;
    
    var source=$(this.selectors.modalTemplate).html();
    this.modalTemplate=Handlebars.compile(source);
    
    var data={};
    data = {
      item: this.item
    }
    
    this.el.append(this.modalTemplate(data));
    this.el.find('form').on('submit', theme.ajaxAddToCart);

    this.el.addClass(this.activeClass);
    this.setActive();
    this.setShortList();
  }
  
  setActive(){
    this.el.addClass(this.activeClass);
    this.el.siblings().removeClass(this.activeClass);
    this.active=1;
  }
  
  setShortList(){
    var __this=this;
    this.shortlistBtn=this.el.find('[data-mode="shortlist"]');
    if(this.shortlist.inShortList(this.item.id)) this.setShortListBtnStatus('disabled');
    this.el.find('[data-mode="shortlist"]').on('click', function(){
      __this.addToShortList();
    });
  }
  
  setShortListBtnStatus(status){
    if(status=='disabled') this.shortlistBtn.addClass('disabled');
    else  this.shortlistBtn.removeClass('disabled');
  }
  
  addToShortList(){
    var __this=this;
    if(!this.shortlist.inShortList(this.item.id)){
      var itemArray=[this.item.id,this.item.shape,this.item.carat,this.item.dimensions,this.item.cut,this.item.color,this.item.clarity,this.item.price,this.item.video];
      this.shortlist.updateStorage(itemArray, -1);
    }
    this.setShortListBtnStatus();
  }
}


class FilterItem {
  
  constructor(el, container, index, root){
    var __this=this;
    this.el=el;
    this.index=index;
    this.duration=this.index*150;
    this.container=$(container);
    this.resultsEl=this.el.find('.results');
    this.root=root;
    this.el.appendTo(this.container);
    this.el[0].offsetHeight;
    
    setTimeout(function(){ 
      var el=__this.el.find('.cc-accordion-proxy');
      el.removeClass('inactive');
    }, __this.duration);
    this.filter=this.el.find('> div').attr('data-filter');
    this.type=this.el.find('> div').attr('data-type');
    if(this.type=='min-max') {
      this.setupMinMax()
    }
    if(this.type=='slider') {
      this.setupSlider()
    }
    if(this.type=='slider--list') {
      this.setupSliderList()
    }
    if(this.type=='list'){
      this.setupList();
    }
  }
  
  setupList(){
    var __this=this;
    this.label=this.el.find('.cc-checkbox__label');
    this.label.on('click', function(){
      if($(this).is('.active')) $(this).removeClass('active');
      else $(this).addClass('active');
      $(this)[0].offsetHeight;
      setTimeout(function(){ __this.listResults(); }, 10);
    })
  }
  
  listResults(){
    var __this=this;
    var needsColon=0;
    this.queryVals='';
    this.resultsVals=''; 
    this.el.find('.cc-checkbox__label.active').each(function(){
      if(!needsColon) {
        needsColon=1;
      } else {
        __this.queryVals+=':';
        __this.resultsVals+=', ';
      }
      __this.queryVals+=$(this).attr('data-value');
      __this.resultsVals+=$(this).attr('data-label');
    })
    
    this.root.runFilter();
    this.resultsEl.text(this.resultsVals); 
  }
  
  setupSliderList(){
    var __this=this;
    this.sliderEl=this.el.find('.slider');
    this.labelEl=this.el.find('.slider-values');
    this.label=this.labelEl.find('> div');
    
    var valArray=[];
    var labelArray=[];
    var labelLen=this.label.length;
    
    this.labelEl.width(((labelLen)*100/(labelLen-1))+'%');
    this.label.width((100/(labelLen))+'%');
    
    this.el.find('.slider-values > div').each(function(){
      valArray.push($(this).attr('data-value'));
      labelArray.push($(this).attr('data-label'));
    })
    this.val1=valArray[0];
    this.val2=valArray[valArray.length-1];
    
    this.sliderEl.slider({
      range: true,
      min: 0,
      max: valArray.length-1,
      step: 1,
      values: [ 0, valArray.length ],
      slide: function(e, ui) {
        
      },
      stop: function(e, ui){
        __this.sliderListResults(e, ui);
      }
     });
  }
  
  setupSlider(){
    var __this=this;
    this.sliderEl=this.el.find('.slider');
    this.minEl=this.el.find('[data-value-min]');
    var minVal=Number(this.minEl.attr('data-value-min'));
    this.val1=minVal;
    this.maxEl=this.el.find('[data-value-max]');
    var maxVal=Number(this.maxEl.attr('data-value-max'));
    this.val2=maxVal;
    
    var step=.01; 
    if(maxVal>99) step=1;
    
    if(this.filter=='price') step=1;
    
    this.sliderEl.slider({
      range: true,
      min: minVal,
      max: maxVal,
      step: step,
      values: [ minVal, maxVal ],
      slide: function(e, ui) {
        
      },
      stop: function(e, ui){
        __this.sliderResults(e, ui);
      }
     });
  }
  
  sliderListResults(e, ui){
    var __this=this;
    
    var index0=ui.values[0];
    var index1=ui.values[1];
    
    this.val1=this.label.eq(index0).attr('data-value');
    this.val2=this.label.eq(index1).attr('data-value');
    
    this.root.runFilter();
  }
  
  sliderResults(e, ui){
    var __this=this;
    this.val1=ui.values[0];
    this.val2=ui.values[1];
    
    this.minEl.val(this.val1);
    this.maxEl.val(this.val2);
    
    this.root.runFilter();
    
    if(this.filter=='price') this.resultsEl.text('$'+this.val1+' – $'+this.val2)
    else this.resultsEl.text(this.val1.toFixed(2)+' – '+this.val2)
  }
  setupMinMax(){
    var __this=this;
    this.minEl=this.el.find('[data-value-min]');
    this.maxEl=this.el.find('[data-value-max]');
    
    var intMin=this.minEl.parent().find('> div > div').first().attr('data-value');
    var intMax=this.maxEl.parent().find('> div > div').first().attr('data-value');
    
    this.minEl.val(intMin);
    this.maxEl.val(intMax);
    
    this.el.find('.cc-item').on('click', function(){
      var input=$(this).find('input');
      input.attr('data-prev', input.val());
      $(this).addClass('active')
    }).hover(function(){}, function(){
      var input=$(this).find('input');
      $(this).removeClass('active');
      if(input.val()==''){
        input.val(input.attr('data-prev'));
      }
    })
    this.el.find('.cc-item input').on('focus', function(){
      $(this).val('');
    }).on('change', function(){
      __this.minMaxResults();
    })
    this.el.find('.cc-item > * > *').on('click', function(){
      var intVal=$(this).attr('data-value');
      $(this).parent().parent().find('input').val(intVal);
      __this.minMaxResults();
    })
  }
  minMaxResults(){
    var __this=this;
    
    var minVal=this.minEl.val().toLowerCase();
    var maxVal=this.maxEl.val().toLowerCase();
    
    if(typeof minVal!='undefined' && typeof maxVal!='undefined'){
      
      this.val1=minVal=='any'?0:minVal;
      this.val2=maxVal=='any'?9999999:maxVal;
      
      this.root.runFilter();
    }
  }
  returnQuery(){
    var query='';
    
    if(this.type=='slider'||this.type=='slider--list') {
      query=this.filter+'='+this.val1+':'+this.val2;
    }else if(this.type=='min-max'){
      query=this.filter+'='+this.val1+':'+this.val2;
    }else if(this.type=='list'){
      if(this.queryVals=='') query='';
      else query=this.filter+'='+this.queryVals;
    }
    return query;
  }
}

class ShortList {
  
  constructor(){
    var __this=this;
    this.storage=JSON.parse(localStorage.getItem('shortlist'));
    this.perRow=4;
    
    this.selectors={
      container: '#ShortlistContainer',
      containerRow: '#ShortlistContainer .swiper-wrapper',
      containerEmpty: '#ShortlistContainer .swiper-wrapper',
      template: '#ShortListTemplate',
      templateRow: '#ShortListTemplateRow',
      templateEmpty: '#ShortListTemplateRowEmpty',
      bubble: '.shortlist--bubble',
      btn: '[href="#shortlist"]'
    };
    
    var source=$(this.selectors.template).html();
    this.template=Handlebars.compile(source);
    
    var sourceRow=$(this.selectors.templateRow).html();
    this.templateRow=Handlebars.compile(sourceRow);
    
    var sourceEmpty=$(this.selectors.templateEmpty).html();
    this.templateEmpty=Handlebars.compile(sourceEmpty);
    
    this.setupNull();
    this.buildShortList();
    this.setupToggle();
  }
  
  setupToggle(){
    
    var __this=this;
    
    $('body').on('click', function(e){
      var el=$(e.target);
      
      if(!$('body').is('[data-shortlist-active]')) {
        var willOpen=0;
        if(el.is(__this.selectors.btn)||el.closest(__this.selectors.btn).length){
          e.preventDefault();
          $('body').attr('data-shortlist-active', 1);
        }
      }else{
        var willClose=1;
        if(el.closest('#ShortlistContainer').length) {
          
          //remove item
          if(el.is('[href="#remove"]')){
            var id=el.attr('data-id');
            __this.removeItem(id);
          }else if(el.closest('[href="#remove"]').length){
            var id=el.closest('[href="#remove"]').attr('data-id');
            __this.removeItem(id);
          }
          willClose=0;
          
          // click close button
          if(el.is('[href="/close"]')||el.closest('[href="/close"]').length){
            e.preventDefault();
            willClose=1;
          }
        }
        if(willClose) $('body').removeAttr('data-shortlist-active');
      }
    });
  }
  setupNull(){
    
    if(this.storage==null) {
      this.storage={};
      this.storage['shortlist']=Array();
    }
  }
  buildShortList(){
    var __this=this;
    var items = [];
    var item = {};
    var data = {};
    var animation_row = 1;
    var stoneLength=this.storage['shortlist'].length;
    
    $(this.selectors.container).html('');
    $(this.selectors.container).append(this.template(data));
    
    this.storage['shortlist'].forEach((stone)=>{
      item={
        id: stone[0],
        shape: stone[1],
        carat: Number(stone[2]).toFixed(2),
        dimensions: stone[3],
        cut: stone[4],
        color: stone[5],
        clarity: stone[6],
        price: stone[7], 
        video: stone[8]
      };
      items.push(item);
      
      $(this.selectors.containerRow).append(this.templateRow(item));
      
    });
    
    var overFlow=this.perRow-stoneLength;
    
    if(overFlow>0) {
      for(var x=0; x<overFlow; x++){
        $(this.selectors.containerRow).append(this.templateEmpty());
      }
    }
    
    /*
    data={
      items: items, 
      foo: 'bar'
    };
    */
    
    $(this.selectors.bubble).text(stoneLength);
    
    this.swiperEl=$('#ShortlistContainer .swiper-container');
    this.slide=this.swiperEl.find('.swiper-slide');
    this.next=$('#ShortlistContainer [href="#next"]');
    this.prev=$('#ShortlistContainer [href="#prev"]');
     
    this.setupSlider();
    this.setupVideos();
    
    //this.slide.find('form').on('submit', theme.ajaxAddToCart);
    this.slide.find('form').map((index, el)=>{
      console.log(el, index+'  xxxelement?');
      new StoneToInventory(el);
    })
    
    $(window).resize(function(){ __this.setupVideos(); })
    
    this.setupRemove();
  }
  
  setupVideos(){
    if(!this.slide.length) return;
    
    this.slide.each(function(){
      
      var container=$(this).find('.stone-video-container');
      if(typeof container.attr('data-src')!='undefined'){
        var iframeSrc=container.attr('data-src');
        
        if(iframeSrc!=''){
          if(!$(this).find('iframe').length) $('<iframe></iframe>').appendTo(container);
          var iframe=container.find('iframe');
          var width=container.width();
          var src=iframeSrc.split('video/')[0]+'video/'+width+'/'+width+'/';
          iframe.attr('width', width).attr('height', width);
          iframe.attr('src', src);
        }
      }
    })
  }
  
  setupSlider(){
    var __this=this;
    this.swiper=new Swiper(this.swiperEl[0], {
      slidesPerView: 'auto', 
      loop: false
      // Responsive breakpoints
    })
    
    this.next.on('click', function(){
      console.log('next');
      __this.swiper.slideNext();
      //__this.updateIndex();
    })
    this.prev.on('click', function(){
      __this.swiper.slidePrev();
      //__this.updateIndex();
    })
    this.swiper.on('touchEnd', function(){
      //setTimeout(function(){ __this.updateIndex(); }, 150);
    })
  }
  
  setupRemove(){
    var __this=this;
    
    /*
    $(this.selectors.container).find('[href="#remove"]').on('click', function(e){
      e.preventDefault()
      var id=$(this).attr('data-id');
      __this.removeItem(id);
    })
    */
  }
  removeItem(id) {
    var __this=this;
    this.storage['shortlist'].forEach((stone, index)=>{  
      var compare=stone[0];
      if(compare==id) { 
        __this.updateStorage(stone, index);
      }
    })
  }
  inShortList(id) {
    var __this=this;
    this.refreshStorage();
    var isIn=0;
    this.storage['shortlist'].forEach((stone)=>{
      var compare=stone[0];
      if(compare==id) { 
        isIn=1;
      }
    })
    return isIn;
  }
  refreshStorage(){
    this.storage=JSON.parse(localStorage.getItem('shortlist'));
    this.setupNull();
  }
  returnStorage(){
    
    if(this.storage==null) {
      return null;
    }else return this.storage;
  }
  updateStorage(el, pos){
    console.log(el);
    if(pos==-1){
      this.storage['shortlist'][this.storage['shortlist'].length]=el;
    } else this.storage['shortlist'].splice(pos, 1);
    localStorage.setItem('shortlist', JSON.stringify(this.storage));
    
    this.refreshStorage();
    this.buildShortList();
  }
}

class StoneToInventory {
  
  constructor(el) {
    this.el=$(el);
    this.formData=this.el.serializeArray();
    this.btn=this.el.find('.btn');
    this.btn.on('click', this.submitStone.bind(this));
  }
  submitStone(e) {
    
    var __this=this;
    
    e.preventDefault();
    
    const stoneId = this.el.find('input[name="stoneId"]').val();
    
    $.ajax({
      url: theme.routes.stoneGetPath+'stoneId='+stoneId,
      async: false,
      cache: false
    }).done((stoneData) => {
      // TODO: error handling
      
      var newFormData=__this.formData.map(item => {
        if (newItem=stoneData.find((element) => element.name == item.name)) {
          return newItem;
        } else {
          return item;
        }
      });
      console.log(newFormData);
      //__this.addStoneToCart();
      //processAddToCart($form, $btn, updateStickyButton, newFormData);
    });
  }
  addStoneToCart(){
    this.el.on('submit', theme.ajaxAddToCart);
    this.el.trigger('submit');
  }
}

class Loading {
  
  constructor(container){
    
    var __this=this;
    this.container=container;
    this.durationOne=2000;
    this.durationTwo=4000;
    this.durationInit=4000;
    var intLoading=this.container.find('.loading-element')
    if(intLoading.length) this.el=intLoading;
    else {
      this.el=$('<div class="loading-element"><b><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 225.46 88.29" style="enable-background:new 0 0 225.46 88.29;" xml:space="preserve"><path class="st0" d="M198.98,67.9c-0.77-10.43-10.28-18.68-21.91-18.68c-5.4,0-10.34,1.78-14.17,4.73 c-5.39-11.11-17.66-18.87-31.95-18.87c-8.68,0-16.62,2.87-22.72,7.62c-8.32-12.22-23.26-20.37-40.31-20.37 c-26.12,0-47.3,19.13-47.3,42.74c0,0.95,0.04,1.9,0.11,2.84H198.98z"/></svg><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 225.46 88.29" style="enable-background:new 0 0 225.46 88.29;" xml:space="preserve"><path class="st0" d="M198.98,67.9c-0.77-10.43-10.28-18.68-21.91-18.68c-5.4,0-10.34,1.78-14.17,4.73 c-5.39-11.11-17.66-18.87-31.95-18.87c-8.68,0-16.62,2.87-22.72,7.62c-8.32-12.22-23.26-20.37-40.31-20.37 c-26.12,0-47.3,19.13-47.3,42.74c0,0.95,0.04,1.9,0.11,2.84H198.98z"/></svg><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 225.46 88.29" style="enable-background:new 0 0 225.46 88.29;" xml:space="preserve"><path class="st0" d="M198.98,67.9c-0.77-10.43-10.28-18.68-21.91-18.68c-5.4,0-10.34,1.78-14.17,4.73 c-5.39-11.11-17.66-18.87-31.95-18.87c-8.68,0-16.62,2.87-22.72,7.62c-8.32-12.22-23.26-20.37-40.31-20.37 c-26.12,0-47.3,19.13-47.3,42.74c0,0.95,0.04,1.9,0.11,2.84H198.98z"/></svg><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 225.46 88.29" style="enable-background:new 0 0 225.46 88.29;" xml:space="preserve"><path class="st0" d="M198.98,67.9c-0.77-10.43-10.28-18.68-21.91-18.68c-5.4,0-10.34,1.78-14.17,4.73 c-5.39-11.11-17.66-18.87-31.95-18.87c-8.68,0-16.62,2.87-22.72,7.62c-8.32-12.22-23.26-20.37-40.31-20.37 c-26.12,0-47.3,19.13-47.3,42.74c0,0.95,0.04,1.9,0.11,2.84H198.98z"/></svg></b></div>');
      this.el.appendTo(this.container);
    }
    this.timer=null;
    this.positionInit();
  }
  positionInit(){
    var __this=this;
    this.el.attr('data-position', 'init');
    //this.timer=setTimeout(function( ){ __this.positionOne(); }, this.durationOne)
  }
  positionOne(){
    var __this=this;
    this.el.attr('data-position', 'one');
    this.timer=setTimeout(function( ){ __this.positionTwo(); }, this.durationOne)
  }
  positionTwo(){
    var __this=this;
    this.el.attr('data-position', 'two');
    this.timer=setTimeout(function( ){ __this.positionInit(); }, this.durationInit)
  }
  positionEnd(){
    clearTimeout(this.timer);
    this.el.attr('data-position', 'stop');
  }
}

$(function(){
  
  $(document).ready(function() {
    
    new CollectionInit();
  })
})
  